module.exports = __webpack_public_path__ + "img/download-hover.f8ed4369.svg";